import { PropsWithChildren, useEffect } from 'react';

import { RouterProvider, RouterProviderProps } from '../contexts/router';

import { CMSProvider, CMSProviderProps } from './services/content';

export type SharedComponentsProviderProps = {
  cms: CMSProviderProps;
  router?: RouterProviderProps;
};

/**
 * All shared configuration for Header + Footer components
 */
export const SharedComponentsProvider = ({ children, cms, router }: PropsWithChildren<SharedComponentsProviderProps>) => {
  let inner = children;

  useEffect(() => {
    if (window.DD_LOGS && window.DD_LOGS.getLogger?.('shared-header-footer') === undefined) {
      window.DD_LOGS.createLogger?.('shared-header-footer', {
        context: { service: 'shared-header-footer', env: import.meta.env.MODE },
      });
    }
  }, []);

  if (router) {
    inner = <RouterProvider {...router}>{inner}</RouterProvider>;
  }

  return <CMSProvider {...cms}>{inner}</CMSProvider>;
};
